/**
 * Feedback Hook
 *
 * React hook for submitting user feedback
 */

import { useMutation } from '@tanstack/react-query';
import { feedbacksApi, type CreateFeedbackRequest, type CreateFeedbackResponse } from '@/shared/lib/api/feedbacks-api';

/**
 * Hook to submit user feedback
 * Endpoint: POST /feedbacks
 *
 * @example
 * ```tsx
 * const { mutate: submitFeedback, isPending, isSuccess } = useSubmitFeedback();
 * submitFeedback({ text: 'Great app!' });
 * ```
 */
export function useSubmitFeedback() {
  return useMutation<CreateFeedbackResponse, Error, CreateFeedbackRequest>({
    mutationFn: feedbacksApi.create,
  });
}
